import { render, staticRenderFns } from "./QuotationTableCostsViewerCafezal.vue?vue&type=template&id=61d1973f"
import script from "./QuotationTableCostsViewerCafezal.vue?vue&type=script&lang=js"
export * from "./QuotationTableCostsViewerCafezal.vue?vue&type=script&lang=js"
import style0 from "./QuotationTableCostsViewerCafezal.vue?vue&type=style&index=0&id=61d1973f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports